module.exports = __webpack_public_path__ + "static/media/04Demo Photo-ink.d5693d7b.jpeg";